"use strict";
exports.__esModule = true;
exports.ResizeTableContextProvider = exports.ResizeTableContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var DEFAULT_STATE = {
    data: { draggingColumnId: null },
    actions: { setDraggingColumnId: function () { return null; } }
};
exports.ResizeTableContext = react_1.createContext(DEFAULT_STATE);
var ResizeTableContextProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(null), draggingColumnId = _b[0], setDraggingColumnId = _b[1];
    return (react_1["default"].createElement(exports.ResizeTableContext.Provider, { value: { data: { draggingColumnId: draggingColumnId }, actions: { setDraggingColumnId: setDraggingColumnId } } }, children));
};
exports.ResizeTableContextProvider = ResizeTableContextProvider;
//# sourceMappingURL=ResizeTableContext.js.map